module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1"
    }
  }, [_c('b', [_vm._v("Top Ten Things about ")]), _c('br'), _c('b', [_vm._v("Approaching the Paranormal World ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e174111"
    }
  }, [_c('b', [_vm._v("1. ")]), _vm._v("Read all you can about ghosts, psychics, and hauntings.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e175011"
    }
  }, [_c('b', [_vm._v("2. ")]), _vm._v("Write down any paranormal experiences that you or your family members have had.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e176111"
    }
  }, [_c('b', [_vm._v("3. ")]), _vm._v("Maintain a skeptical but open mind and attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e176811"
    }
  }, [_c('b', [_vm._v("4. ")]), _vm._v("Be prepared to enter uncharted waters.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e177511"
    }
  }, [_c('b', [_vm._v("5. ")]), _vm._v("Keep a journal of your experiences with any sort of psychic experiments involving pendulums, scrying, séances, or any other means of divination.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e179411"
    }
  }, [_c('b', [_vm._v("6. ")]), _vm._v("Sign up for a class to learn from experienced teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e180211"
    }
  }, [_c('b', [_vm._v("7. ")]), _vm._v("Ask questions and follow your instincts.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e180911"
    }
  }, [_c('b', [_vm._v("8. ")]), _vm._v("Respect the research and work that has gone before.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e181711"
    }
  }, [_c('b', [_vm._v("9. ")]), _vm._v("Be prepared to be disappointed sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1",
    attrs: {
      "id": "d7e182411"
    }
  }, [_c('b', [_vm._v("10. ")]), _vm._v("Be prepared to be totally amazed!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb57dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elli_9781605507057_epub_c10_r1.vue
// module id = 84
// module chunks = 0